




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// getAllPurchasesListForAuthUser
// GETALLPURCHASESLISTFORAUTHUSER
const GETALLPURCHASESLISTFORAUTHUSER= createAsyncThunk(
  "getAllPurchasesListForAuthUser/getAllPurchasesListForAuthUser",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllPurchasesListForAuthUserSlice = createSlice({
  name: "getAllPurchasesListForAuthUserSlice",
  initialState: {
    getAllPurchasesListForAuthUser: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllPurchasesListForAuthUser: (state) => {
        state.getAllPurchasesListForAuthUser.loading = false
        state.getAllPurchasesListForAuthUser.error = false
        state.getAllPurchasesListForAuthUser.data = []
        state.getAllPurchasesListForAuthUser.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLPURCHASESLISTFORAUTHUSER.fulfilled, (state, action) => {
      state.getAllPurchasesListForAuthUser = {
        ...state.getAllPurchasesListForAuthUser,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLPURCHASESLISTFORAUTHUSER.pending, (state, action) => {
      state.getAllPurchasesListForAuthUser = {
        ...state.getAllPurchasesListForAuthUser,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLPURCHASESLISTFORAUTHUSER.rejected, (state, action) => {
      state.getAllPurchasesListForAuthUser = {
        ...state.getAllPurchasesListForAuthUser,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllPurchasesListForAuthUserAction = {
    GETALLPURCHASESLISTFORAUTHUSER,
};

export { getAllPurchasesListForAuthUserAction };
export default getAllPurchasesListForAuthUserSlice.reducer;
export const {setInitialStateOfgetAllPurchasesListForAuthUser} = getAllPurchasesListForAuthUserSlice.actions
